import { Link } from "react-router-dom";
import CtaButton from "@/components/shared/CtaButton";
import { Reveal } from "@/components/motion/Reveal";

export default function CtaSection({
  eyebrow = "Get Started",
  heading = "Ready to make your business visible in AI search?",
  sub = "Every AI recommendation is a business opportunity. Let's make sure the answer is your brand.",
  source = "final-cta",
}) {
  return (
    <section className="relative bg-[#111111] text-white overflow-hidden" data-testid="cta-section">
      <div className="absolute inset-0 bg-grid-dark opacity-60" />
      <div
        className="absolute -top-32 left-1/2 -translate-x-1/2 h-[420px] w-[720px] rounded-full blur-3xl"
        style={{ background: "radial-gradient(circle, rgba(11,99,246,0.28), transparent 70%)" }}
      />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-12 py-24 lg:py-32">
        <Reveal>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#0B63F6]">{eyebrow}</p>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="font-display text-4xl lg:text-6xl font-bold tracking-tightest mt-5 max-w-4xl leading-[1.02]">
            {heading}
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="text-lg text-[#A1A1AA] mt-6 max-w-2xl">{sub}</p>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="mt-10 flex flex-wrap gap-4">
            <CtaButton variant="accent" source={source} title="Book Consultation" testId="cta-book-consultation">
              Book Consultation
            </CtaButton>
            <CtaButton variant="outlineLight" source={source} title="Talk to a GEO Expert" testId="cta-talk-expert">
              Talk to a GEO Expert
            </CtaButton>
            <Link
              to="/tools"
              data-testid="cta-free-check"
              className="inline-flex items-center gap-2 rounded-full px-7 py-3.5 text-[15px] font-medium text-[#A1A1AA] hover:text-white transition-colors"
            >
              Try the free AI Visibility Checker
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
